import React from "react";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {useGTMTracking} from "../../../app/hooks/useGTMTracking";
import {chatConvoStartersSelector, openChatbot, sendMessageToBot, updateInitializationType} from "../../chatbotSlice";
import {ConvoStarterButton} from "./ConvoStarterButton";
import {InitializationType, InputType} from "../../../api/generated";

export const ChatConvoStarters: React.FC = () => {
    const starters = useAppSelector(chatConvoStartersSelector);
    const { qrClick } = useGTMTracking();

    const dispatch = useAppDispatch();

    const handleConvoStarterClick = (starter: string) => {
        dispatch(openChatbot());
        dispatch(updateInitializationType(InitializationType.OnButtonClick))
        dispatch(sendMessageToBot({message: starter, inputType: InputType.Button}));
        qrClick(starter);
    }

    return <div className="flex flex-col items-end gap-2">
        {starters.map((starter: string, index: number) => (
            <ConvoStarterButton key={index} starter={starter} handleConvoStarterClick={handleConvoStarterClick}/>
        ))}
    </div>
};
